import RewardSide from "./RewardSide";

export default RewardSide;